import AccountSettings from './account';
import BookingProcess from './booking';
import PaymentProcess from './payment';
import PostTripProcess from './postTrip';
import Cancellation from './cancellation';

export default [
  AccountSettings,
  BookingProcess,
  PaymentProcess,
  PostTripProcess,
  Cancellation
];
